import type { Domain } from "@amzn/d16-g-cdb-publisher-portal-typescript-client";
import * as React from "react";

import { CardContainer } from "../common/styled.components";
import { ActionBar } from "../createOnDemandInsight/ActionBar";

import { DeepLinkTemplateAccountPicker } from "./DeepLinkTemplateAccountPicker";

export interface DeepLinkAccountPickerSectionProps {
    domain: Domain;
    templateId: string;
    templateName: string;
    domainIdentifier: string;
    onAccountSelect: (accountId: string) => void;
    onCancel: () => void;
    onClose: () => void;
}

export const DeepLinkAccountPickerSection: React.FunctionComponent<
    DeepLinkAccountPickerSectionProps
> = ({
    domain,
    templateId,
    templateName,
    domainIdentifier,
    onAccountSelect,
    onCancel,
    onClose,
}) => {
    return (
        <section>
            <ActionBar
                domainIdentifier={domainIdentifier}
                templateIdentifier={templateId}
                templateName={templateName}
            />
            <CardContainer>
                <DeepLinkTemplateAccountPicker
                    domain={domain}
                    templateId={templateId}
                    onAccountSelect={onAccountSelect}
                    onCancel={onCancel}
                    onClose={onClose}
                />
            </CardContainer>
        </section>
    );
};
